const zh = {
	title: '标签标准库',
	searchTips: '请输入名称',
	professionalLabel: '专业标签',
	teamLabel: '团队标签',
	createLabel: '创建标签',
	noDataTips: '暂无标签，赶紧去添加吧',
	createProfessionalLabels: '创建专业标签',
	cancel: '取消',
	confirm: '确定',
	labelName: '标签名称',
	desc: '描述',
	tagNamePlaceholder: '字数限制${num}个',
	descPlaceholder: '字数限制${num}个',
	tagNameEmptytTips: '标签名称不能为空',
	majorLogo: '上传标签图标',
	teamLogo: '上传团队logo',
	creater: '创建人:',
	createrTime: '创建时间:',
	add: '添加',
	delete: '删除',
	tagsWaitingToBeAdded: '待添加的标签',
	createTeamTag: '创建团队标签',
	addTag: '创建团队标签',
	labelDetails1: '专业标签详情',
	labelDetails2: '团队标签详情',
	modifySuccess: '修改成功',
	logo1: '专业图标 (点击可修改)',
	logo2: '团队图标 (点击可修改)',
	update: '同步',
	plTagMame: '请输入标签名称',
	projectManager: '项目经理',
	labelOwner: '标签拥有者',
	tipsTitle: '提示：以下为标签来源信息，仅供参考：',
	tgaNamenoEmpty: '标签名称不能为空',
	nameCannotExceed: '标签名称不能超过🐂个字段',
	decsExceed: '描述不能超过150个字',
	addProfessionalTag: '添加专业标签',
	addMajorTag: '添加专业标签',
	addMajorTagDetail: '专业标签详情',
	uploadMajorTaglogo: '上传专业图标',
	addTeamtag: '添加团队标签',
};

export default zh;
